module.exports = __webpack_public_path__ + "static/Ernst-Wit-07f48b4c4942029905b6667fe32ed5a8.jpg";